import React, { useState } from "react";
import _uniqueId from "lodash/uniqueId";
import { Form } from "react-bootstrap";

export default function FieldCheckbox({
  label,
  itemLabel,
  group = "",
  information,
  checked,
  style,
  styleLabel = {},
  onChange,
  required = false,
  disabled = false,
  readonly = false,
  classNames = "",
  classNamesLabel = "",
  hideLabel = false,
  error,
}) {
  const [id] = useState(_uniqueId("field_"));

  return (
    <div className={"form-group " + classNames} style={style}>
      {!hideLabel ? (
        <label htmlFor={id} style={styleLabel} className={classNamesLabel}>
          {label}
        </label>
      ) : null}
      <Form.Check
        onChange={(x) => onChange(x.target.checked)}
        checked={checked}
        disabled={disabled}
        readOnly={readonly}
        required={required}
        label={itemLabel}
        name={group}
        type="checkbox"
        id={id}
        value={checked}
        className={classNamesLabel}
      />
      {information ? (
        <small id={id + "Help"} className="form-text text-muted">
          {information}
        </small>
      ) : null}
      {error ? (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {error}
        </div>
      ) : null}
    </div>
  );
}
